Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};
Greenmile.PanelBuilder.Fields = Greenmile.PanelBuilder.Fields || {};

Greenmile.PanelBuilder.Fields.Render = (function () {

    function Render (field, entity) {

        field = field || { type: 'TEXT' };

        this.render = function () {

            var fieldRendered = new Greenmile.PanelBuilder.Fields.Base(field, entity);

            var clazz = Greenmile.PanelBuilder[field.type];
            if (clazz) {
                fieldRendered = new clazz(field, entity);
            }

            return fieldRendered;
        };
    };

    return Render;

}());